import ApplyPromoCode from './ApplyPromoCode';

export default ApplyPromoCode;
